/* tslint:disable */
/* eslint-disable */
/**
 * Account App Tier Operations API
 * APIs for the Account App Tier Microservice
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Name } from './Name';
import {
    NameFromJSON,
    NameFromJSONTyped,
    NameToJSON,
} from './Name';

/**
 * 
 * @export
 * @interface LegalEntity
 */
export interface LegalEntity {
    /**
     * Legal entity type
     * @type {string}
     * @memberof LegalEntity
     */
    type?: LegalEntityTypeEnum;
    /**
     * account tax id (separate from profile tax id) used for bonus payouts etc.
     * @type {string}
     * @memberof LegalEntity
     */
    taxId?: string;
    /**
     * 
     * @type {Name}
     * @memberof LegalEntity
     */
    name?: Name;
}


/**
 * @export
 */
export const LegalEntityTypeEnum = {
    NonLegalEntity: 'NON_LEGAL_ENTITY',
    LegalEntity: 'LEGAL_ENTITY'
} as const;
export type LegalEntityTypeEnum = typeof LegalEntityTypeEnum[keyof typeof LegalEntityTypeEnum];


/**
 * Check if a given object implements the LegalEntity interface.
 */
export function instanceOfLegalEntity(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LegalEntityFromJSON(json: any): LegalEntity {
    return LegalEntityFromJSONTyped(json, false);
}

export function LegalEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'taxId': !exists(json, 'taxId') ? undefined : json['taxId'],
        'name': !exists(json, 'name') ? undefined : NameFromJSON(json['name']),
    };
}

export function LegalEntityToJSON(value?: LegalEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'taxId': value.taxId,
        'name': NameToJSON(value.name),
    };
}

